var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 411,
    viewBox: "0 0 466 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.558 143.228C370.175 159.41 351.357 176.43 328.463 193.57L272.368 231.207C265.056 227.251 241.683 213.108 216.272 193.57C175.759 162.766 147.712 132.92 134.766 106.551C116.547 69.3936 133.688 24.925 173.122 7.78474C206.923 -6.83839 249.474 1.91152 272.248 29.24C287.83 10.6614 314.319 0.832761 338.172 0.832761C362.024 0.832761 361.065 3.23 371.973 7.66488C384.199 13.0587 394.267 20.9695 401.818 30.6783C429.267 100.078 384.438 143.109 384.438 143.109L384.558 143.228Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.306 307.199L279.319 337.165L439.933 243.553C441.851 242.474 443.889 241.875 446.166 241.875C453.957 241.875 460.789 246.909 462.707 253.981L464.385 260.093C466.423 268.004 463.306 276.275 456.354 281.189L286.511 399.852C281.836 403.208 276.442 405.606 270.689 407.164L262.658 409.201C257.264 410.64 251.511 410.52 246.237 408.842L77.9512 356.342C70.28 353.945 61.8897 354.544 54.698 357.901L1 382.832",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5457 278.912L122.661 244.272C127.216 242.833 132.01 242.354 136.805 242.953L322.47 265.128C330.861 266.087 336.854 273.158 336.135 281.069L335.296 290.538C334.456 299.049 327.025 305.641 317.916 305.761L221.307 307.319L182.352 306.001",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.799 264.049L386.956 237.08C390.792 235.762 395.107 235.762 398.942 237.08C407.812 239.957 413.685 247.868 413.685 256.738V258.895",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M384.558 143.228C370.175 159.41 351.357 176.43 328.463 193.57L272.368 231.207C265.056 227.251 241.683 213.108 216.272 193.57C175.759 162.766 147.712 132.92 134.766 106.551C116.547 69.3936 133.688 24.925 173.122 7.78474C206.923 -6.83839 249.474 1.91152 272.248 29.24C287.83 10.6614 314.319 0.832761 338.172 0.832761C362.024 0.832761 361.065 3.23 371.973 7.66488C384.199 13.0587 394.267 20.9695 401.818 30.6783",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M437.057 80.5406V99.8383H409.729V125.609H389.232V99.8383H361.904V80.5406H389.232V54.7703H409.729V80.5406H437.057Z",
    fill: "#A3C5EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.0697cad4.svg";
export { ForwardRef as ReactComponent };